"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MarkupInputLabel = exports.RateInputLabel = exports.ExpenseInputLabel = exports.TimeInputLabel = exports.errorCodes = exports.inputTypes = void 0;

var _core = require("@material-ui/core");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _atoms = require("../../../atoms");

var _intl = require("../../../intl");

var _molecules = require("../../../molecules");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var inputTypes = {
  expense: 'expense-rate-card',
  time: 'time-rate-card'
};
exports.inputTypes = inputTypes;
var errorCodes = {
  nameEmpty: {
    ident: 'ratecard.form.nameCannotBeEmpty',
    highlight: 'name'
  },
  amountEmpty: {
    ident: 'ratecard.form.timeRatesMustHaveAmount',
    highlight: 'amount'
  },
  markupEmpty: {
    ident: 'ratecard.form.expenseRatesMustHaveMarkup',
    highlight: 'markup'
  },
  nameNotUnique: {
    ident: 'ratecard.form.namesMustBeUnique',
    highlight: 'name'
  }
};
exports.errorCodes = errorCodes;
var standardSpacing = 1;
var fontSize = 14;
var doubleFontSize = fontSize * 2;
var marginSize = 6;
var paddingSize = 5;
var IdentifierIcon = /*#__PURE__*/(0, _styledComponents["default"])(_atoms.Icon).withConfig({
  displayName: "RateInput__IdentifierIcon"
})(["", ""], function (_ref) {
  var _ref$theme = _ref.theme,
      palette = _ref$theme.palette,
      typography = _ref$theme.typography;
  return (0, _styledComponents.css)(["background-color:", ";color:black;border-radius:50%;padding:", ";font-size:", ";height:", "px;align-items:center;justify-content:center;display:flex !important;width:", "px;"], palette.grey[300], typography.pxToRem(paddingSize), typography.pxToRem(fontSize), doubleFontSize, doubleFontSize);
});

var Row = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "RateInput__Row"
})(["display:flex;align-items:center;"]);

var ErrorRow = /*#__PURE__*/(0, _styledComponents["default"])(Row).withConfig({
  displayName: "RateInput__ErrorRow"
})(["", ""], function (_ref2) {
  var palette = _ref2.theme.palette;
  return (0, _styledComponents.css)(["color:", ";"], palette.error.main);
});
var InputFields = /*#__PURE__*/(0, _styledComponents["default"])(_core.Grid).withConfig({
  displayName: "RateInput__InputFields"
})(["", ""], function (_ref3) {
  var spacing = _ref3.theme.spacing;
  return (0, _styledComponents.css)(["margin:0 ", ";"], spacing(standardSpacing));
});
var CurrencySymbol = /*#__PURE__*/(0, _styledComponents["default"])(_core.InputAdornment).withConfig({
  displayName: "RateInput__CurrencySymbol"
})(["", ""], function (_ref4) {
  var typography = _ref4.theme.typography;
  return (0, _styledComponents.css)(["margin:0 0 ", " ", ";"], typography.pxToRem(marginSize), typography.pxToRem(marginSize));
});

var TimeInputLabel = function TimeInputLabel() {
  return _react["default"].createElement(_intl.IntlMessage, {
    ident: "ratecard.form.identifierTime"
  });
};

exports.TimeInputLabel = TimeInputLabel;

var ExpenseInputLabel = function ExpenseInputLabel() {
  return _react["default"].createElement(_intl.IntlMessage, {
    ident: "ratecard.form.identifierExpense"
  });
};

exports.ExpenseInputLabel = ExpenseInputLabel;

var RateInputLabel = function RateInputLabel() {
  return _react["default"].createElement(_intl.IntlMessage, {
    ident: "ratecard.form.rate"
  });
};

exports.RateInputLabel = RateInputLabel;

var MarkupInputLabel = function MarkupInputLabel() {
  return _react["default"].createElement(_intl.IntlMessage, {
    ident: "ratecard.form.markup"
  });
};

exports.MarkupInputLabel = MarkupInputLabel;

var NumberInput = function NumberInput(props) {
  return _react["default"].createElement(_molecules.NumberInput, _extends({
    allowNegative: props.allowNegative || false,
    decimalScale: props.decimalScale || 2,
    size: props.size || 'small',
    type: props.type || 'text'
  }, props));
};

var RateInput = function RateInput(_ref5) {
  var _ref5$rate = _ref5.rate,
      id = _ref5$rate.id,
      name = _ref5$rate.name,
      amount = _ref5$rate.amount,
      markupPercentage = _ref5$rate.markupPercentage,
      nameUntouched = _ref5$rate.nameUntouched,
      amountUntouched = _ref5$rate.amountUntouched,
      markupPercentageUntouched = _ref5$rate.markupPercentageUntouched,
      type = _ref5.type,
      currencySymbol = _ref5.currencySymbol,
      onRateUpdate = _ref5.onRateUpdate,
      onRemoveClick = _ref5.onRemoveClick,
      autoFocus = _ref5.autoFocus,
      error = _ref5.error,
      markupInputProps = _ref5.markupInputProps,
      rateInputProps = _ref5.rateInputProps;
  var handleChange = (0, _react.useCallback)(function (newEntry) {
    return onRateUpdate(_objectSpread({
      id: id,
      name: name,
      amount: amount,
      markupPercentage: markupPercentage,
      type: type,
      nameUntouched: nameUntouched,
      amountUntouched: amountUntouched,
      markupPercentageUntouched: markupPercentageUntouched
    }, newEntry));
  }, [onRateUpdate, id, name, amount, markupPercentage]);
  var handleNameChange = (0, _react.useCallback)(function (inputEvent) {
    return handleChange({
      name: inputEvent.target.value,
      nameUntouched: false
    });
  }, [handleChange]);
  var handleRateChange = (0, _react.useCallback)(function (value) {
    return handleChange({
      amount: value.floatValue,
      amountUntouched: false
    });
  }, [handleChange]);
  var handleMarkupChange = (0, _react.useCallback)(function (value) {
    return handleChange({
      markupPercentage: value.floatValue,
      markupPercentageUntouched: false
    });
  }, [handleChange]);
  var handleRemoveClick = (0, _react.useCallback)(function () {
    onRemoveClick(id);
  }, [id]);
  var showNameError = error && error.highlight === 'name' && !nameUntouched;
  var showAmountError = error && error.highlight === 'amount' && !amountUntouched;
  var showMarkupPercentageError = error && error.highlight === 'markup' && !markupPercentageUntouched;
  var iconName = type === inputTypes.time ? 'clock' : 'money-bill-alt';
  return _react["default"].createElement(Row, null, _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12
  }, _react["default"].createElement(Row, null, _react["default"].createElement(IdentifierIcon, {
    size: "small",
    icon: iconName,
    prefix: "far",
    color: "action"
  }), _react["default"].createElement(InputFields, {
    container: true,
    direction: "row",
    justify: "space-evenly",
    alignItems: "center",
    spacing: 1
  }, _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 6
  }, _react["default"].createElement(_core.FormControl, {
    fullWidth: true,
    required: true
  }, _react["default"].createElement(_atoms.TextField, {
    size: "small",
    fullWidth: true,
    label: type === inputTypes.time ? _react["default"].createElement(TimeInputLabel, null) : _react["default"].createElement(ExpenseInputLabel, null),
    error: showNameError,
    value: name,
    onChange: handleNameChange,
    autoFocus: autoFocus
  }))), _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 3
  }, _react["default"].createElement(_core.FormControl, {
    fullWidth: true,
    required: true
  }, _react["default"].createElement(NumberInput, _extends({
    label: _react["default"].createElement(RateInputLabel, null),
    prefix: currencySymbol,
    value: amount,
    onValueChange: handleRateChange,
    error: showAmountError
  }, rateInputProps)))), _react["default"].createElement(_core.Grid, {
    item: true,
    xs: 3
  }, type === inputTypes.expense && _react["default"].createElement(NumberInput, _extends({
    label: _react["default"].createElement(MarkupInputLabel, null),
    value: markupPercentage,
    onValueChange: handleMarkupChange,
    error: showMarkupPercentageError,
    suffix: "%"
  }, markupInputProps)))), _react["default"].createElement(_molecules.RemoveButton, {
    size: "small",
    onClick: handleRemoveClick,
    "data-testid": "remove-button"
  })), (showAmountError || showNameError || showMarkupPercentageError) && _react["default"].createElement(ErrorRow, null, _react["default"].createElement(_intl.IntlMessage, {
    ident: error.ident
  }))));
};

RateInput.propTypes = {
  rate: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    name: _propTypes["default"].string,
    amount: _propTypes["default"].number,
    markupPercentage: _propTypes["default"].number
  }),
  type: _propTypes["default"].oneOf(Object.values(inputTypes)).isRequired,
  currencySymbol: _propTypes["default"].string.isRequired,
  onRateUpdate: _propTypes["default"].func.isRequired,
  onRemoveClick: _propTypes["default"].func.isRequired,
  autoFocus: _propTypes["default"].bool,
  markupInputProps: _propTypes["default"].object,
  rateInputProps: _propTypes["default"].object
};
RateInput.defaultProps = {
  rate: {},
  autoFocus: false
};
var _default = RateInput;
exports["default"] = _default;